module.exports = __webpack_public_path__ + "img/icon-11-green.b271d3b9.svg";